import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const download = (url: string) => http.get(url, { responseType: 'blob' });

const reservations = () => download(API_ENDPOINTS.exportReservations);
const transactions = () => download(API_ENDPOINTS.exportTransactions);
const invoices = () => download(API_ENDPOINTS.exportInvoices);
const invoiceLineItems = () => download(API_ENDPOINTS.exportInvoiceLineItems);

const ExportService = { reservations, transactions, invoices, invoiceLineItems };

export default ExportService;
